import FiLock from '@meronex/icons/fi/FiLock';
import icon from './StyledIcon';
export default icon(FiLock);
